module.exports = __webpack_public_path__ + "img/partner11.d13f9d08.png";